import $ from 'jquery'
import 'jquery-placeholder'
;(function () {
  // init jquery placeholder shim for older browsers that require it

  // $.placeholder script is in vendor/
  var init

  On.PlaceholderShim = class PlaceholderShim {
    constructor() {
      if (!$.isFunction($.fn.placeholder)) {
        return
      }
      $('input, textarea').placeholder()
    }
  }

  init = function () {
    return new On.PlaceholderShim()
  }

  $(document).ready(init)
}.call(window))
